import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import Products from './components/Products';
import Home from './components/Home';
import Opportunities from "./components/Opportunities"
import ScrollToTop from "./components/ScrollToTop"; 
import AOS from 'aos';
import 'aos/dist/aos.css';
import './css/styles.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true, // Reveal each block once instead of on every scroll past
      offset: 60,
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    });
  }, []);
  return (
    <Router>
       <ScrollToTop /> 
      <Header />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/services" element={<Services />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/products" element={<Products />} />
        
        <Route path="/opportunities" element={<Opportunities />} />
        
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
